import React from "react";
import { SearchBarProductFilterIcon } from "./SearchBarIcons";

export const CREDIT_ALERT_FILTER_OPTIONS = [
  { key: "", label: "همه وضعیت‌های اعتبار" },
  { key: "at_risk", label: "اعتبار در خطر (قرمز یا زرد)" },
  { key: "red", label: "فقط اعتبار قرمز" },
  { key: "yellow", label: "فقط اعتبار زرد" },
];

const ShopInsightFilterModal = ({ activeFilter, onApply, onClose }) => {
  const [draft, setDraft] = React.useState(activeFilter);

  React.useEffect(() => {
    setDraft(activeFilter);
  }, [activeFilter]);

  const toggleFlag = (key) => {
    setDraft((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const apply = () => {
    onApply(draft);
    onClose();
  };

  const reset = () => {
    onApply({ crm_open: false, crm_sla: false, credit_alert: "" });
    onClose();
  };

  return (
    <div className="sort-modal shop-insight-filter-modal">
      <div className="sort-modal-head">
        <h2>
          <SearchBarProductFilterIcon />
          فیلتر CRM و اعتبار
        </h2>
        <button type="button" className="sort-modal-close" onClick={onClose} aria-label="بستن">
          ×
        </button>
      </div>
      <p className="shop-insight-filter-desc">
        فروشگاه‌ها را بر اساس وضعیت CRM یا هشدار اعتبار محدود کنید.
      </p>

      <div className="shop-insight-filter-section">
        <div className="shop-insight-filter-section-title">CRM</div>
        <div className="sort-modal-options">
          <button
            type="button"
            className={`sort-modal-option ${draft.crm_open ? "active" : ""}`}
            onClick={() => toggleFlag("crm_open")}
          >
            سرنخ CRM باز
          </button>
          <button
            type="button"
            className={`sort-modal-option ${draft.crm_sla ? "active" : ""}`}
            onClick={() => toggleFlag("crm_sla")}
          >
            نقض SLA
          </button>
        </div>
      </div>

      <div className="shop-insight-filter-section">
        <div className="shop-insight-filter-section-title">اعتبار</div>
        <div className="sort-modal-options">
          {CREDIT_ALERT_FILTER_OPTIONS.map((option) => (
            <button
              key={option.key || "all"}
              type="button"
              className={`sort-modal-option ${draft.credit_alert === option.key ? "active" : ""}`}
              onClick={() => setDraft((prev) => ({ ...prev, credit_alert: option.key }))}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      <div className="shop-insight-filter-actions">
        <button type="button" className="shop-insight-filter-apply" onClick={apply}>
          اعمال فیلتر
        </button>
        <button type="button" className="sort-modal-option shop-insight-filter-reset" onClick={reset}>
          بازنشانی
        </button>
      </div>
    </div>
  );
};

export const ShopInsightFilterButton = ({ active, onClick }) => (
  <div
    className={`svg-rec ${active ? "svg-rec-active-filter" : ""}`}
    onClick={onClick}
    role="button"
    tabIndex={0}
    aria-label="فیلتر CRM و اعتبار"
  >
    <SearchBarProductFilterIcon />
  </div>
);

export default ShopInsightFilterModal;
